import { selectAuthState } from '../store/auth/auth.selectors';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@app/core/store/app.state';
import { filter, map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { landingRouteFor } from '../routing/landing-route';

@Injectable({
  providedIn: 'root'
})

export class RoleGuard implements CanActivate {
  constructor(private store: Store<AppState>,
    private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.store.select(selectAuthState).pipe(
      filter((auth) => !auth.loading),
      take(1),
      map((auth) => {
        const user = auth.user;
        const targetRoles = route.data['targetRoles'] as Array<string> | undefined;
        const roles = targetRoles && this.hasParameter(route, 'userId')
          ? targetRoles
          : route.data['roles'] as Array<string>;
        const userRoles = user?.roles ?? (user?.role ? [user.role] : []);
        const roleMatch = userRoles.some(role => roles.includes(role));
        return roleMatch
          ? true
          : this.router.parseUrl(landingRouteFor(userRoles, user?.employmentStatus));
      })
    );
  }

  private hasParameter(route: ActivatedRouteSnapshot | null, name: string): boolean {
    for (let current = route; current; current = current.parent) {
      if (current.paramMap?.has(name)) return true;
    }
    return false;
  }
}
